import { render, staticRenderFns } from "./UpdateUserProfileModal.vue?vue&type=template&id=cb96dc48"
import script from "./UpdateUserProfileModal.vue?vue&type=script&lang=ts"
export * from "./UpdateUserProfileModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports